import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import { Button, Modal, Icon } from 'components/Elements'
import { usePopup } from 'hooks'
import { JobInviteCreate } from 'features/job/components/JobInvite'

export const InviteControl = ({
  invited = false,
  className = '',
  onSuccess,
  candidate,
  job,
  blocked = false,
  jobSelect,
}) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const { visible, open, close } = usePopup()

  const onSubmitSuccess = data => {
    close()

    onSuccess && onSuccess(data)
  }

  const onClick = () => {
    if (blocked) {
      navigate('/billing/subscription')
    } else {
      open()
    }
  }

  return (
    <>
      <div>
        <Button
          className={className}
          onClick={onClick}
          outline={invited}
          disabled={invited}
          size={'sm'}
          width={'w-sm'}
          rightIcon={blocked ? <Icon name={'blocked'} className={'font-size-14'} /> : null}
        >
          {invited ? t('invited') : t('invite')}
        </Button>
      </div>

      <Modal visible={visible} centered onClose={close} title={t('invite')}>
        <JobInviteCreate
          job={job}
          candidate={candidate}
          onSuccess={onSubmitSuccess}
          jobSelect={jobSelect}
        />
      </Modal>
    </>
  )
}

InviteControl.propTypes = {
  invited: PropTypes.bool,
  className: PropTypes.string,
  onSuccess: PropTypes.func,
  candidate: PropTypes.object,
  job: PropTypes.object,
  blocked: PropTypes.bool,
  jobSelect: PropTypes.bool,
}
